const messagesIt = require("./messages.it");
const messagesEn = require("./messages.en");

module.exports = {
  it: { baseUrl: "/it", label: "Italiano 🇮🇹", messages: messagesIt },
  en: { baseUrl: "/en", label: "English 🇬🇧", messages: messagesEn },
};
